import React, { useState, useEffect } from 'react';
import { ReviewSales, SalesRejection } from '../../API/JobApproval';
import FloatingLabel from '../../Components/FloatingLabel';
import { Button } from 'react-bootstrap';
import DOMPurify from 'dompurify';

export default ({ jobId, rl, approval, jobNotes, loadNotes }) => {

    const [note, setNote] = useState({
        "title": "Sales Review",
        "description": "",
        "jobId": jobId
    });


    useEffect(() => {
        if (!jobNotes || !Array.isArray(jobNotes))
            return;

        const matchingSection = jobNotes.find(section => section.header === "Sales Review");
        if (!matchingSection || !Array.isArray(matchingSection.notes))
            return;

        const matchingNote = matchingSection.notes.find(n => n.title === "Sales Review");
        if (matchingNote) {
            setNote(prev => ({
                ...prev,
                title: matchingNote.title,
                description: matchingNote.description,
            }));
        }
    }, [jobNotes]);

    const Approve = () => {
        let payload = {
            id: parseInt(jobId),
            approval: true,
            title: note.title,
            description: note.description
        }
        ReviewSales(payload)
            .then(res => {
                if (res.success) {
                    rl();
                    loadNotes();
                }
            })
    }

    const Reject = () => {
        let payload = {
            id: parseInt(jobId),
            approval: false,
            title: note.title,
            description: note.description
        }
        SalesRejection(payload)
            .then(res => {
                if (res.success) {
                    rl();
                    loadNotes();
                }
            })
    }

    const EditNote = (key, value) => {
        let noteCopy = { ...note };
        noteCopy[key] = value;
        setNote(noteCopy);
    }

    return (
        <div>
            <div className="row">
                <div className="col">
                    <h4>Sales Approval</h4>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    {approval.jobApprovalId !== 0 ? `Approved by: ${approval.approver} on ${approval.approvalDate}` : "No Approval"}
                </div>
            </div>
            {(!approval.edit && note.description.length > 0) &&
                <div className="row mt-1">
                    <div className="col">
                        <strong>Note:</strong>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(note.description.replace(/\n/g, '<br />'))
                            }}
                        />
                    </div>
                </div>
            }
            {approval.edit &&
                <>
                    <div className="row">
                        <div className="col">
                        <FloatingLabel id="NoteBody"
                            component="textarea"
                            value={note.description}
                            onChange={(e) => EditNote('description', e.target.value)}
                            placeholder="Note Body" required />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col text-right">
                            <Button className="enc-button mr-1" onClick={Reject}>Reject</Button>
                            <Button className="enc-button" onClick={Approve}>Approve</Button>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}
